import { defineMessages } from 'react-intl';

import CarouselEdit from './CarouselEdit';
import CarouselView from './CarouselView';
import { carouselSchema } from './schema';

import iconSVG from '@plone/volto/icons/slider.svg';

defineMessages({
  cachesarousel: {
    id: 'Carousel',
    defaultMessage: 'Carousel',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.carouselBlock = {
    id: 'carouselBlock',
    title: 'Carousel',
    icon: iconSVG,
    group: 'layout',
    view: CarouselView,
    edit: CarouselEdit,
    blockSchema: carouselSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
